import { render, staticRenderFns } from "./TarefaPage.vue?vue&type=template&id=2d92c4e7"
import script from "./TarefaPage.vue?vue&type=script&lang=js"
export * from "./TarefaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports